import { render, staticRenderFns } from "./TcreditnotesView.vue?vue&type=template&id=2ee3f609&scoped=true"
import script from "./TcreditnotesView.vue?vue&type=script&lang=js"
export * from "./TcreditnotesView.vue?vue&type=script&lang=js"
import style0 from "./TcreditnotesView.vue?vue&type=style&index=0&id=2ee3f609&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee3f609",
  null
  
)

export default component.exports